var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDomainDisabled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12_1834)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.70998 2.39C0.31998 2.78 0.31998 3.41 0.70998 3.8L1.99998 5.1V19C1.99998 20.1 2.89998 21 3.99998 21H17.9L20.19 23.29C20.58 23.68 21.21 23.68 21.6 23.29C21.99 22.9 21.99 22.27 21.6 21.88L2.11998 2.39C1.72998 2 1.09998 2 0.70998 2.39ZM5.99998 19H3.99998V17H5.99998V19ZM5.99998 15H3.99998V13H5.99998V15ZM3.99998 11V9H5.99998V11H3.99998ZM9.99998 19H7.99998V17H9.99998V19ZM7.99998 15V13H9.99998V15H7.99998ZM12 19V17H13.9L15.9 19H12ZM7.99998 5H9.99998V7H9.54998L12 9.45V9H19C19.55 9 20 9.45 20 10V17.45L22 19.45V9C22 7.9 21.1 7 20 7H12V5C12 3.9 11.1 3 9.99998 3H5.54998L7.99998 5.45V5ZM16 11H18V13H16V11Z",
    fill: "#FFFFFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_1834"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomainDisabled);
export default __webpack_public_path__ + "static/media/domain_disabled.9b3b6a013f3cec2dde16b9f6b5c9692e.svg";
export { ForwardRef as ReactComponent };